export default __webpack_public_path__ + "locales/vi/Files.json?hash=02bc94738778fb15cd39ad1ff3f4d0e3";